import { Link, useLocation } from 'react-router-dom';
import React from 'react';
import { Button } from '@repo/ui/components/Button';
import { cn } from '@repo/ui/utils';

type NavButtonProps = {
  to: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  hasPermission?: boolean;
};

const NavButton = ({
  to,
  icon,
  children,
  className,
  hasPermission = true,
}: NavButtonProps) => {
  const location = useLocation();
  const isActive = location.pathname === to;

  if (!hasPermission) return null;

  const handleClick = () => {
    const skipLink = document.getElementById('skip-to-content');
    if (skipLink) {
      skipLink.focus();
    }
  };

  return (
    <Button
      variant={isActive ? 'secondary' : 'ghost'}
      className={cn(
        'w-full justify-start nav-item hover:bg-primary-hover hover:text-primary-foreground',
        isActive && 'bg-primary-hover text-primary-foreground',
        className
      )}
      asChild
    >
      <Link to={to} onClick={handleClick}>
        {icon && <span className="mr-2">{icon}</span>}
        {children}
      </Link>
    </Button>
  );
};

export default NavButton;
